import type { CSSProperties } from 'react';
import { containFitScale } from '../../../infrastructure/runtime';
import '../components/atomic/layout/app_screen/app_screen.css';
import { SunBeams } from '../components/atomic/atmosphere/sun_beams/SunBeams';
import { FrameHeader } from '../components/atomic/dialog/frame_header/FrameHeader';
import { SolidFrameBackground } from '../components/atomic/dialog/solid_frame_background/SolidFrameBackground';
import { SkyAtmosphere } from '../components/composite/atmosphere/sky_atmosphere/SkyAtmosphere';
import { useAppFit } from '../../hooks/useAppFit';
import type { ScreenViewProps } from '../shared/screenViewProps';
import { TitleBackground } from './content/TitleBackground';
import { TicketReward } from '../components/atomic/dialog/ticket_reward/TicketReward';
import { GoBackButton } from './go_back_button/GoBackButton';
import { DialogTexts } from './texts/DialogTexts';
import type { DailyStrikeScreenController } from './DailyStrikeScreenController';
import type { DailyStrikeScreenModel } from './DailyStrikeScreenModelScreen';
import './daily_strike_screen.css';

export type DailyStrikeScreenViewProps = ScreenViewProps<
  DailyStrikeScreenModel,
  DailyStrikeScreenController
>;

/** Daily strike success screen (Figma concept 154:25756). */
export function DailyStrikeScreenView({
  model,
  controller,
}: DailyStrikeScreenViewProps) {
  const fit = useAppFit();
  const contain = containFitScale(fit.scale);

  return (
    <div className="app-screen daily-strike-screen">
      <SkyAtmosphere variant="welcome" />
      <div
        className="daily-strike-plaques"
        style={
          {
            '--fit-contain-inv-x': String(contain.invX),
            '--fit-contain-inv-y': String(contain.invY),
            '--fit-contain-uniform': String(contain.uniform),
          } as CSSProperties
        }
      >
        <SunBeams className="daily-strike-screen__sun-beams" />
        <SolidFrameBackground />
        <FrameHeader showSubHeader={false} />
        <TicketReward rewardPasses={model.rewardPasses} />
        <TitleBackground />
        <DialogTexts />
        <GoBackButton onClick={controller.handleGoBack} />
      </div>
    </div>
  );
}
